<template>
  <vue-input v-mask="'####-##-##'" v-bind="$attrs" v-on="$listerners" @change.native="validateDate" ref="input" />
</template>

<script>
import VueInput from '@/components/vue-components/vue-input/VueInput.vue';

export default {
    name: 'date-input',
    inheritAttrs: false,
    components: {
        VueInput
    },
    methods: {
        validateDate(e) {
            const invalidDate = isNaN(new Date(e.target.value));

            if (invalidDate) {
                e.target.setCustomValidity('Ogiltigt datum');
            }
            else {
                e.target.setCustomValidity('');
            }
        },
        getValue() {
            return this.$refs.input.getValue();
        }
    }
}
</script>

<style>

</style>